import { get, has } from 'lodash';
import { GENERIC_REQUEST_ERROR } from 'utils/constants';

/**
 * normaliseError
 *
 * Transforms an error to a default shape and handles cases where error is not standard
 *
 * @param  {Object} error              The error to transform
 * @param  {String} defaultDescription The description to provide in case the error is not standard
 * @return {Object}                    The transformed error with keys description,
 *                                     errors and status
 */
export default (error, defaultDescription = GENERIC_REQUEST_ERROR) => ({
  description:
    get(error, 'response.data.description') ||
    get(error, 'message') ||
    defaultDescription,
  errors: has(error, 'response.data.errors') ? error.response.data.errors : [],
  ...(has(error, 'response.status') && {
    status: error.response.status
  }),
  ...(has(error, 'response.data.unrecoverable') && {
    unrecoverable: error.response.data.unrecoverable
  })
});
